document.addEventListener('DOMContentLoaded', function () {
  const section = document.querySelector('#shopify-section-template--29598965825905__collection_list_jwEYVT');
  if (!section) return;

  const scroller = section.querySelector('slideshow-slides');
  if (!scroller) return;

  const originalSlides = Array.from(scroller.children);
  if (originalSlides.length === 0) return;

  const total = originalSlides.length;

  // Duplica 3x para ter margem suficiente
  for (let i = 0; i < 3; i++) {
    originalSlides.forEach(s => {
      const clone = s.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      scroller.append(clone);
    });
  }

  originalSlides.reverse().forEach(s => {
    const clone = s.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    scroller.prepend(clone);
  });

  requestAnimationFrame(() => {
    const gap = parseInt(getComputedStyle(scroller).gap) || 8;
    const slideWidth = scroller.children[0].offsetWidth + gap;

    // Começa no primeiro slide real (após os clones iniciais)
    let currentIndex = total;
    scroller.style.scrollBehavior = 'auto';
    scroller.scrollLeft = slideWidth * currentIndex;
    scroller.style.scrollBehavior = '';

    function goTo(index) {
      currentIndex = index;
      scroller.style.scrollBehavior = 'smooth';
      scroller.scrollLeft = slideWidth * currentIndex;

      // Após a animação, reposiciona silenciosamente se estiver nos clones
      setTimeout(() => {
  scroller.style.scrollBehavior = 'auto';
  if (currentIndex <= 0) {
    scroller.classList.add('is-jumping');
    currentIndex += total;
    scroller.scrollLeft = slideWidth * currentIndex;
    requestAnimationFrame(() => scroller.classList.remove('is-jumping'));
  } else if (currentIndex >= total * 3) {
    scroller.classList.add('is-jumping');
    currentIndex -= total;
    scroller.scrollLeft = slideWidth * currentIndex;
    requestAnimationFrame(() => scroller.classList.remove('is-jumping'));
  }
  scroller.style.scrollBehavior = '';
}, 800);
    }

    const prevBtn = section.querySelector('.slideshow-control--previous');
    const nextBtn = section.querySelector('.slideshow-control--next');

    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        goTo(currentIndex + 1);
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        goTo(currentIndex - 1);
      });
    }
  });
});

/* A PARTIR DAQUI É MOBILE */

document.addEventListener('DOMContentLoaded', function () {
  if (window.innerWidth > 749) return;

  const section = document.querySelector('#shopify-section-template--29598965825905__collection_list_jwEYVT');
  if (!section) return;

  const scroller = section.querySelector('slideshow-slides');
  if (!scroller) return;

  const originalSlides = Array.from(scroller.children);
  if (originalSlides.length === 0) return;

  const total = originalSlides.length;

  [...originalSlides].reverse().forEach(s => {
    const clone = s.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    scroller.prepend(clone);
  });

  [...originalSlides].forEach(s => {
    const clone = s.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    scroller.append(clone);
  });

  requestAnimationFrame(() => {
    const gap = parseInt(getComputedStyle(scroller).gap) || 8;
    const slideWidth = scroller.children[0].offsetWidth + gap;

    let currentIndex = total;
    let isAnimating = false;

    scroller.style.scrollBehavior = 'auto';
    scroller.scrollLeft = slideWidth * currentIndex;
    scroller.style.scrollBehavior = '';

    function goTo(index) {
      if (isAnimating) return;
      isAnimating = true;
      currentIndex = index;

      scroller.style.scrollBehavior = 'smooth';
      scroller.scrollLeft = slideWidth * currentIndex;

      let scrollEndTimer;
      function onScroll() {
        clearTimeout(scrollEndTimer);
        scrollEndTimer = setTimeout(() => {
          scroller.removeEventListener('scroll', onScroll);
          scroller.style.scrollBehavior = 'auto';

          if (currentIndex <= 0) {
            currentIndex += total;
            scroller.scrollLeft = slideWidth * currentIndex;
          } else if (currentIndex >= total * 2) {
            currentIndex -= total;
            scroller.scrollLeft = slideWidth * currentIndex;
          }

          scroller.style.scrollBehavior = '';
          isAnimating = false;
        }, 100);
      }

      scroller.addEventListener('scroll', onScroll);
    }

    const prevBtn = section.querySelector('.slideshow-control--previous');
    const nextBtn = section.querySelector('.slideshow-control--next');

    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        goTo(currentIndex + 1);
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        goTo(currentIndex - 1);
      });
    }
  });
});
